// src/components/SpacesList.js
import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaUsers, FaTimes, FaMapMarkerAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../App.css';

const spacesData = [
  {
    id: 1,
    name: "Sala Conferenze \"Danilo Dolci\"",
    level: "Piano Terra",
    description: "Sala conferenze dedicata a Danilo Dolci, ideale per convegni, assemblee e incontri pubblici.",
    capacity: 40,
    tags: ["Conferenze", "Assemblee", "Convegni"],
    images: [
      "./imgspazi/1.jpeg"
    ]
  },
  {
    id: 2,
    name: "Sala Principale",
    level: "Piano Terra",
    description: "Ampia sala polivalente per eventi, workshop e attività culturali della comunità.",
    capacity: 50,
    tags: ["Workshop", "Eventi", "Cultura"],
    images: [
      "./imgspazi/2.jpeg"
    ]
  },
  {
    id: 3,
    name: "Cortile",
    level: "Esterno",
    description: "Spazio esterno all'aperto perfetto per eventi nella bella stagione, mercatini e attività ricreative.",
    capacity: 100,
    tags: ["Outdoor", "Eventi", "Mercaticni"],
    images: [
      "./imgspazi/fuori.jpeg"
    ]
  }
];

// Helper per gestire i percorsi delle immagini in caso di deploy su sottocartella
const getPublicPath = (p) => {
  const base = window.location.pathname.startsWith('/PrenotaSpazi') ? '/PrenotaSpazi' : '';
  return `${base}/${p.replace(/^\.\//, '').replace(/^\//, '')}`;
};

// Componente helper per gestire l'effetto sfocato al caricamento
function ImageWithLoader({ src, alt, fit = 'cover', isAbsolute = true }) {
  const [loaded, setLoaded] = useState(false);

  // Resetta lo stato se l'immagine cambia (es. nel carosello)
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  const containerStyle = isAbsolute ? {
    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
    background: '#111', overflow: 'hidden', zIndex: 1
  } : {
    position: 'relative', width: '100%', height: '100%', background: '#111',
    overflow: 'hidden', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'
  };

  return (
    <div style={containerStyle}>
      <img
        src={getPublicPath(src)}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: fit,
          objectPosition: 'center',
          transition: 'opacity 0.6s ease-out, filter 0.8s ease-out, transform 0.8s ease-out',
          opacity: loaded ? 1 : 0,
          filter: loaded ? 'blur(0px)' : 'blur(12px)',
          transform: loaded ? 'scale(1)' : 'scale(1.03)',
          display: 'block'
        }}
      />
    </div>
  );
}

function SpacesList({ onBack, onBookingClick }) {
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const nextImage = (e) => {
    e.stopPropagation();
    if (selectedSpace) {
      setCurrentImageIndex((prev) => (prev === selectedSpace.images.length - 1 ? 0 : prev + 1));
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    if (selectedSpace) {
      setCurrentImageIndex((prev) => (prev === 0 ? selectedSpace.images.length - 1 : prev - 1));
    }
  };

  const openModal = (space) => {
    setSelectedSpace(space);
    setCurrentImageIndex(0);
  };

  return (
    <div style={{

      minHeight: '100dvh',
      padding: '40px 20px',
      fontFamily: "'Poppins', sans-serif"
    }}>

      {/* HEADER */}
      <div className="glass-panel responsive-padding" style={{ maxWidth: '1200px', margin: '0 auto 40px auto', padding: '30px', borderRadius: '30px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <button onClick={onBack} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'white',
          padding: '10px 20px',
          borderRadius: '30px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '14px',
          color: '#222',
          fontWeight: 'bold',
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
          transition: 'transform 0.2s'
        }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
          <FaArrowLeft /> Torna alla Home
        </button>
        <h1 style={{ color: '#222', fontSize: '36px', margin: '15px 0 5px 0' }}>Spazi Disponibili</h1>
        <p style={{ color: '#444', fontSize: '18px', margin: 0 }}>Scopri tutti gli spazi del CIVIC</p>
      </div>

      {/* GRIGLIA CARD */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '30px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {spacesData.map(space => (
          <div
            key={space.id}
            onClick={() => openModal(space)}
            className="glass-panel"
            style={{
              padding: '0',
              borderRadius: '20px',
              overflow: 'hidden',
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              background: 'rgba(255, 255, 255, 0.85)',
              border: '1px solid rgba(255,255,255,0.5)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 32px 0 rgba(31, 38, 135, 0.15)';
            }}
          >
            {/* Immagine Card (Mostra solo la prima) */}
            <div style={{ width: '100%', aspectRatio: '4 / 3', overflow: 'hidden', position: 'relative' }}>
              <ImageWithLoader src={space.images[0]} alt={space.name} fit="cover" />
              <div style={{ position: 'absolute', bottom: 10, left: 10, background: 'rgba(0,0,0,0.6)', color: 'white', padding: '4px 10px', borderRadius: '10px', fontSize: '12px', backdropFilter: 'blur(4px)', zIndex: 10 }}>
                <FaMapMarkerAlt style={{ marginRight: 5 }} /> {space.level}
              </div>
            </div>

            {/* Contenuto Card */}
            <div style={{ padding: '24px' }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '22px', color: '#222' }}>{space.name}</h3>
              <p style={{ color: '#555', fontSize: '14px', lineHeight: '1.5', marginBottom: '20px', height: '42px', overflow: 'hidden' }}>
                {space.description}
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#444', fontSize: '14px', marginBottom: '20px', fontWeight: '600' }}>
                <FaUsers color="#007bff" /> Max {space.capacity} persone
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {space.tags.map((tag, index) => (
                  <span key={index} style={{ background: '#eee', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', color: '#555', fontWeight: '500' }}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL CON CAROSELLO */}
      {selectedSpace && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
          backdropFilter: 'blur(8px)'
        }} onClick={() => setSelectedSpace(null)}>

          <div className="space-detail-modal modal-animate" onClick={(e) => e.stopPropagation()}>

            {/* TASTO CHIUDI (X) */}
            <button onClick={() => setSelectedSpace(null)} style={{ position: 'absolute', top: '15px', right: '15px', background: 'rgba(255,255,255,0.8)', border: 'none', borderRadius: '50%', width: '35px', height: '35px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.2)', zIndex: 20 }}>
              <FaTimes size={18} color="#333" />
            </button>

            {/* --- CAROSELLO --- */}
            <div className="space-carousel-container" style={{ position: 'relative', background: '#111', width: '100%', aspectRatio: '4 / 3', overflow: 'hidden' }}>

              <ImageWithLoader
                src={selectedSpace.images[currentImageIndex]}
                alt={selectedSpace.name}
                fit="cover"
                isAbsolute={true}
              />


              {/* Frecce navigazione (solo se c'è più di 1 foto) */}
              {selectedSpace.images.length > 1 && (
                <>
                  <button onClick={prevImage} style={{ zIndex: 10, position: 'absolute', left: '15px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaChevronLeft />
                  </button>
                  <button onClick={nextImage} style={{ zIndex: 10, position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%', width: '40px', height: '40px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaChevronRight />
                  </button>
                </>
              )}

              {/* Pallini indicatori */}
              <div style={{ position: 'absolute', bottom: '15px', width: '100%', display: 'flex', justifyContent: 'center', gap: '8px', zIndex: 10 }}>
                {selectedSpace.images.map((_, index) => (
                  <div key={index} style={{
                    width: '8px', height: '8px', borderRadius: '50%',
                    background: index === currentImageIndex ? 'white' : 'rgba(255,255,255,0.4)',
                    transition: 'all 0.3s'
                  }}></div>
                ))}
              </div>

            </div>

            <div className="responsive-padding" style={{ padding: '25px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                <h2 style={{ margin: 0, fontSize: '32px', color: '#222' }}>{selectedSpace.name}</h2>
                <span style={{ background: '#222', color: 'white', padding: '6px 15px', borderRadius: '20px', fontWeight: 'bold', fontSize: '14px' }}>
                  {selectedSpace.level}
                </span>
              </div>

              <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#555', marginBottom: '30px' }}>
                {selectedSpace.description}
              </p>

              <div className="responsive-modal-body" style={{ borderTop: '1px solid #ddd', paddingTop: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
                  <FaUsers size={24} color="#007bff" /> Capienza: {selectedSpace.capacity}
                </div>

                <button
                  onClick={() => {
                    setSelectedSpace(null);
                    if (onBookingClick) onBookingClick();
                  }}
                  style={{
                    background: 'linear-gradient(45deg, #007bff, #0056b3)',
                    color: 'white', border: 'none', padding: '15px 30px', borderRadius: '15px',
                    fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
                    boxShadow: '0 5px 15px rgba(0,123,255,0.4)',
                    transition: 'transform 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  Prenota questo spazio
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SpacesList;